/**
 * Per-user Backstage feature flag that gates zero-day (severity `zero-day`)
 * surfacing in the entity view actions table: the "Due now" due-date cell, the
 * findings-summary banner, and the row highlight.
 *
 * Namespaced with the `ys-` prefix to match the convention used by
 * {@link GATED_MEASUREMENTS} (`ys-<category>-<measurement>`) and avoid
 * colliding with other Backstage feature flags, which are global within the
 * app. Registered in the yardstick-react plugin `featureFlags` array so it
 * appears in `/settings/feature-flags` at app bootstrap (OFF by default for
 * all users, including admins).
 */
export const ZERO_DAY_FLAG_KEY = 'ys-zero-day';
